import React, { useState } from "react";
import "../styles/theme.css";
import { useUXContext } from "./UXContext";

const READER_MODE_KEY = "newsCompare:readerMode";

// tiny helper just for logging readerMode; safe fallback if missing
function getReaderModeForLog() {
  const raw = localStorage.getItem(READER_MODE_KEY);
  if (raw == null) return true; // or false, whichever you consider your default
  try { return JSON.parse(raw) === true; }
  catch { return String(raw).toLowerCase() === "true"; }
}

const HeadlineList = ({ articles, setArticles, handleArticleClick, selectedArticle }) => {
  const { mode } = useUXContext();
  const [sort, setSort] = useState("date");

  const handleSortChange = (value) => {
    setSort(value);
    const sorted = [...articles];
    if (value === "source") {
      sorted.sort((a, b) =>
        (a.source?.name || "").localeCompare(b.source?.name || "")
      );
    } else if (value === "date") {
      sorted.sort(
        (a, b) => new Date(b.publishedAt) - new Date(a.publishedAt)
      );
    }
    setArticles(sorted);
  };

  if (mode === "url") return null;

  return (
    <>
      {mode !== "url" && articles.length > 0 && (
        <>
          <div className="sort-options">
            <label className="sort-option">
              <input
                type="radio"
                name="sort"
                value="date"
                checked={sort === "date"}
                onChange={() => handleSortChange("date")}
              />
              Date
            </label>
            <label className="sort-option">
              <input
                type="radio"
                name="sort"
                value="source"
                checked={sort === "source"}
                onChange={() => handleSortChange("source")}
              />
              Source
            </label>
          </div>

          {articles.map((article, i) => (
            <div
              key={i}
              onClick={() => {
                console.log('FLOW LOG: 1️⃣ HeadlineList: Article selected', {
                  url: article.url,
                  readerMode: getReaderModeForLog(),
                });

                // Tell the app a new article was chosen (so SentimentPanel enters waiting immediately)
                window.dispatchEvent(new CustomEvent('newscompare:article-submitted', {
                  detail: { source: 'headline-list', url: article.url }
                }));

                // Mark the app busy right away (NavBar listener will collapse/dim)
                window.dispatchEvent(new CustomEvent('newscompare:busy', {
                  detail: { busy: true, reason: 'article_submit' }
                }));

                //  helps SentimentPanel accept the first hash after a reset
                try { localStorage.setItem('newsCompare:lastPostedArticle', article.url); } catch { }

                // then call the parent handler
                handleArticleClick(article);
              }}
              className={`headline-entry ${selectedArticle?.url === article.url ? 'selected' : ''}`}
            >
              {article.image && (
                <div className="headline-img">
                  <img src={article.image} alt={`${article.title}`} />
                </div>
              )}
              <div className="headline-title-entry">{article.title}</div>
              <div className="headline-source">{article.source.name}</div>
            </div>
          ))}
        </>
      )}
    </>
  );
};

export default HeadlineList;
